<template>
  <div class="i-tree-select" @click.stop :style="iTreeStyle">
    <div ref="active">
      <slot name="active">

      </slot>
    </div>

    <transition name="t-scale">
      <div class="panel-wrapper" :class="{normal}" v-if="show" :style="iWrapperStyle">
        <div class="panel elevation-1" :style="panelStyle" v-loading="loading">
          <div class="top">
            <span class="ipy-1 d-block">Select Item</span>
          </div>
          <div class="middle" :style="panelMiddle">
            <el-tree
              @check-change="checkChange"
              :props="props"
              ref="tree"
              :data="datas"
              :node-key="`${props.value}`"
              :default-checked-keys="defaultCheckedKeys"
              :default-expanded-keys="expandedKeys"
              @check="check"
              :check-strictly="checkStrictly || singleCheck"
              show-checkbox>
            </el-tree>
          </div>
          <div class="footer">
            <el-button type="text" @click="checkAll" v-if="showCheckAll">Check All</el-button>
            <el-button type="text" @click="clear">Clear</el-button>
            <!-- <el-button type="text" @click="cancelHandler">取消</el-button>-->
            <!-- <el-button type="text" @click="okHandler">OK</el-button> -->
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true
    },
    normal: {
      type: Boolean,
      default: true
    },
    datas: {
      type: Array,
      default: () => ([])
    },
    defaultCheckedRows: {
      type: Array,
      default: () => ([])
    },
    panelWidth: {
      type: Number,
      default: null
    },
    panelHeight: {
      type: Number,
      default: 300
    },
    zIndex: {
      type: Number,
      default: 100
    },
    top: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    expandFirst: {
      type: Boolean,
      default: false
    },
    showCheckAll: {
      type: Boolean,
      default: false
    },
    singleCheck: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default: () => ({
        label: 'label',
        children: 'children',
        disabled: 'disabled',
        isLeaf: 'isLeaf',
        value: 'value'
      })
    }
  },
  data() {
    return {
      defaultCheckedKeys: [],
      expandedKeys: [],
      checkedRow: this.defaultCheckedRows,
      show: this.value,
    };
  },
  computed: {
    checkedKeys() {
      return this.checkedRows.map(item => item.id)
    },
    panelStyle() {
      if (this.top) {
        return {
          transform: 'translateY(-100%)',
          width: `${this.panelWidth || this.activeWidth}px`,

        }
      } else {
        return {
          width: `${this.panelWidth || this.activeWidth}px`
        }
      }
    },
    panelMiddle() {
      return {
        height: `${this.panelHeight || this.panelHeight}px`
      }
    },
    iTreeStyle() {
      if (this.top) {
        return {
          position: 'relative'
        }
      }else{
        return {}
      }
    },
    iWrapperStyle() {
      if (this.top) {
        return {
          position: 'absolute',
          //top: 0,
          left: 0
        }
      }
      else {
        return {}
      }
    }
  },
  watch: {
    value() {
      this.show = this.value
      this.listen()
    },
    datas() {
      if (this.expandFirst) {
        this.expandedKeys = this.datas.length > 0 ? [this.datas[0][this.props.value]] : []
      }
    },
    defaultCheckedRows() {
      this.defaultCheckedKeys = this.defaultCheckedRows.map(k => k[this.props.value])
    },
    show(val, oldVal) {
      if (val != oldVal) {
        this.$emit('input', val)
      }
    }
  },
  created() {
    this.init()
    this.listen()
  },
  mounted() {
    this.$nextTick(() => {
      this.activeWidth = this.$refs.active.clientWidth
    })
  },
  methods: {
    checkChange(data, checked) {
      if (this.singleCheck && checked) {
        // 只能勾选一个
        this.$refs.tree.setCheckedKeys([data[this.props.value]], false)
        this.$emit('check', [data])
      }
    },
    check(row, state) {
      this.checkedRow = state.checkedNodes.slice()
      this.$emit('half-check', this.$refs.tree.getHalfCheckedNodes().slice())
      this.$emit('check', this.checkedRow)
    },
    okHandler() {
      this.show = false
      this.$emit('check', this.checkedRow)
    },
    clear() {
      this.checkedRow = []
      this.$emit('check', this.checkedRow)
      this.$refs.tree.setCheckedNodes([])
    },
    // cancelHandler() {
    //   this.show = false
    // },
    init() {
      if (this.expandFirst) {
        this.expandedKeys = this.datas.length > 0 ? [this.datas[0][this.props.value]] : []
      }

      this.defaultCheckedKeys = this.defaultCheckedRows.map(k => k[this.props.value])
      this.show = this.value
    },
    listen() {
      if (!this.show) {
        return
      }
      const handle = () => {
        this.show = false
        document.removeEventListener('click', handle)
      }
      document.addEventListener('click', handle)
    },
    checkAll() {
      this.$refs.tree.setCheckedKeys(this.datas.map(k => k[this.props.value]), false)
      this.$emit('check', this.$refs.tree.getCheckedNodes())
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/element-variables.scss";
.i-tree-select {
  overflow: visible;
  z-index: 100;
  .panel-wrapper {
    position: relative;
    transform-origin: 0 -30px;
    height: auto;
    width: auto;
    overflow: visible;
    .panel {
      border-radius: 4px;
      overflow: hidden;
      position: absolute;
      left: 0;
      top: 0px;
      z-index: 100;
      width: 300px;
      .top {
        background-color: $--color-primary;
        color: #fff;
        padding: 0 16px;
        box-sizing: border-box;
        font-size: 14px;
        line-height: 1;
      }
      .middle {
        background-color: #fff;
        padding: 8px;
        box-sizing: border-box;
        overflow: auto;
      }
      .footer {
        background-color: #fff;
        padding: 0 8px;
        box-sizing: border-box;
        border-top: 1px solid #DCDFE6;
        display: flex;
        justify-content: flex-end;
        & /deep/ .el-button {
          margin: 0 12px;
        }
      }
    }

    &.normal {
      .top {
        width: 100%;
      }
      .middle {
        width: 100%;
        min-height: 300px;
      }
    }
  }
}

.t-scale-enter-active, .t-scale-leave-active {
  transition: all 0.3s;
  z-index: 100;
}
.t-scale-enter, .t-scale-leave-to
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0.5);
}

</style>




// WEBPACK FOOTER //
// src/components/tree-select.vue